import { PageId } from 'constants/pages'

export const enum PageIdWoofzPpp {
  DOG_AGE_WOOFZ_PPP = PageId.DOG_AGE_WOOFZ_PPP,
  DOG_OWNER_WOOFZ_PPP = PageId.DOG_OWNER_WOOFZ_PPP,
  TRAINING_COMMANDS_WOOFZ_PPP = PageId.TRAINING_COMMANDS_WOOFZ_PPP,
  URGE_WOOFZ_PPP = PageId.URGE_WOOFZ_PPP,
  DOG_BREED_WOOFZ_PPP = PageId.DOG_BREED_WOOFZ_PPP,
  FACING_CHALLENGES_WOOFZ_PPP = PageId.FACING_CHALLENGES_WOOFZ_PPP,
  FACING_CHALLENGES_2_WOOFZ_PPP = PageId.FACING_CHALLENGES_2_WOOFZ_PPP,
  BEHAVIOR_FREQUENCY_WOOFZ_PPP = PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP,
  URGE_PROGRAM_WOOFZ_PPP = PageId.URGE_PROGRAM_WOOFZ_PPP,
  BEHAVIOR_FEELINGS_WOOFZ_PPP = PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP,
  FIX_BEHAVIOR_WOOFZ_PPP = PageId.FIX_BEHAVIOR_WOOFZ_PPP,
  URGE_4_WOOFZ_PPP = PageId.URGE_4_WOOFZ_PPP,
  COMMANDS_WOOFZ_PPP = PageId.COMMANDS_WOOFZ_PPP,
  PARENT_GOAL_WOOFZ_PPP = PageId.PARENT_GOAL_WOOFZ_PPP,
  TRAINING_PLACE_WOOFZ_PPP = PageId.TRAINING_PLACE_WOOFZ_PPP,
  TRAINING_FREQUENCY_WOOFZ_PPP = PageId.TRAINING_FREQUENCY_WOOFZ_PPP,
  URGE_5_WOOFZ_PPP = PageId.URGE_5_WOOFZ_PPP,
  PREPARE_FLOW_WOOFZ_PPP = PageId.PREPARE_FLOW_WOOFZ_PPP,
  EMAIL_WOOFZ_PPP = PageId.EMAIL_WOOFZ_PPP,
  NEWSLETTER_URGE_WOOFZ_PPP = PageId.NEWSLETTER_URGE_WOOFZ_PPP,
  LAST_CHANCE_OFFER_WOOFZ_PPP = PageId.LAST_CHANCE_OFFER_WOOFZ_PPP,
  WELCOME_TO_WOOFZ_WOOFZ_PPP = PageId.WELCOME_TO_WOOFZ_WOOFZ_PPP,
  SUBSCRIPTIONS_WOOFZ_PPP = PageId.SUBSCRIPTIONS_WOOFZ_PPP,
  CHAT_UPSELL_WOOFZ_PPP = PageId.CHAT_UPSELL_WOOFZ_PPP,
  UPSELL_WOOFZ_PPP = PageId.UPSELL_WOOFZ_PPP,
  UPSELL_FEEDING_GUIDE_WOOFZ_PPP = PageId.UPSELL_FEEDING_GUIDE_WOOFZ_PPP,
  UPSELL_EMOTIONAL_SUPPORT_WOOFZ_PPP = PageId.UPSELL_EMOTIONAL_SUPPORT_WOOFZ_PPP,
  DOWNLOAD_WOOFZ_PPP = PageId.DOWNLOAD_WOOFZ_PPP,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
